var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2205,
    height: 670,
    viewBox: "0 0 2205 670",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 169.709H630.331L693.636 0H61.9566L0 169.709ZM669.395 169.709H952.24C1037.09 169.709 1069.42 172.407 1069.42 224.935C1069.42 300.354 996.688 300.354 905.108 300.354H851.232L1029.02 669.395H1260.69L1131.39 420.233C1220.29 382.517 1279.53 312.481 1279.53 199.345C1279.53 126.611 1252.61 70.0368 1205.46 37.7161C1166.4 10.7779 1132.74 0 996.7 0H730.003L669.395 169.709V169.709ZM1702.42 669.395H1930.04L2080.9 299.005H1702.42V669.395ZM1315.89 669.395H1543.52L1690.31 299.005H1315.89V669.395ZM36.3672 669.395H261.289L394.631 300.354H169.696L36.3672 669.395Z",
    fill: "#AF4A46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M490.258 669.395H708.448L840.441 300.354H624.936L490.258 669.395ZM1586.6 169.709H1884.25V0H1645.85L1586.6 169.709V169.709ZM1954.3 169.709H2134.79L2204.82 0H2016.25L1954.3 169.709V169.709ZM1315.89 169.709H1517.9V0H1315.89V169.709V169.709Z",
    fill: "#AF4A46"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrw);
export default __webpack_public_path__ + "static/media/trw.f6e158d01a2bcfbce486434340ca05bd.svg";
export { ForwardRef as ReactComponent };